import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export const SITE_URL = "https://snap-quote.app";
const DEF_DESC = "Dal sopralluogo al preventivo in pochi minuti. Il Visual Estimator per artigiani e imprese edili.";

const META = {
  "/": ["SnapQuote | Preventivi da foto per artigiani", "SnapQuote è il Visual Estimator per artigiani: dal sopralluogo al preventivo in pochi minuti. Software preventivi per imbianchini, elettricisti, idraulici, piastrellisti e piccole imprese edili."],
  "/login": ["Accedi | SnapQuote", "Accedi a SnapQuote e gestisci sopralluoghi, preventivi e clienti dal tuo smartphone."],
  "/register": ["Prova SnapQuote gratis | SnapQuote", "Crea il tuo account SnapQuote: 3 sopralluoghi AI gratuiti, nessuna carta richiesta, preventivi illimitati."],
  "/privacy": ["Privacy Policy | SnapQuote", "Informativa sul trattamento dei dati personali di SnapQuote."],
  "/termini": ["Termini e Condizioni | SnapQuote", "Termini e condizioni di utilizzo del servizio SnapQuote."],
  "/cookie": ["Cookie Policy | SnapQuote", "Informativa sull'uso dei cookie su SnapQuote."],
  "/preventivo-gratis": ["Preventivo AI Gratis per Artigiani | SnapQuote", "Carica una foto o descrivi il lavoro e crea una bozza di preventivo professionale con l'intelligenza artificiale. Prova SnapQuote gratis, senza registrazione."],
  "/contatti": ["Contatti | SnapQuote", "Contatta il team SnapQuote per informazioni, assistenza o il piano Impresa."],
  "/pacchetti-sopralluoghi": ["Pacchetti sopralluoghi per artigiani | SnapQuote", "Pacchetti da 2, 5, 10 o 25 sopralluoghi qualificati per categoria, validi 90 giorni: più lavori, meno costo a sopralluogo. Con SnapQuote risparmi il 20%.", "og-pacchetti.jpg"],
  "/founder": ["SnapQuote Founders 100 | Platinum a prezzo Founder, solo 100 posti", "Il programma per i primi 100 artigiani: piano Platinum completo, numero Founder, bonus esclusivi e prezzo bloccato. 999 € + IVA all'anno oppure 199 € e poi 83 € al mese.", "og-founder.jpg"],
  "/vision": ["SnapQuote Vision™ | Dalla foto al render arredato e al preventivo", "Fotografa la stanza da ristrutturare, mostra al cliente il render prima e dopo già arredato e crea il preventivo da inviare su WhatsApp.", "og-vision.jpg"],
  "/ai-secretary": ["Sofia AI | La segretaria AI per artigiani · SnapQuote", "Sofia AI risponde alle chiamate, fissa gli appuntamenti e gestisce clienti e promemoria mentre tu lavori.", "og-sofia.jpg"],
  "/protezione": ["SnapQuote Saldo Protetto | Nuovi Sopralluoghi e Incassi Protetti", "Acquisisci sopralluoghi qualificati, gestisci preventivi e contratti con AI e scopri SnapQuote Saldo Protetto, riservato a Platinum e Founder 100.", "og-protezione.jpg"],
  "/casa": ["SnapQuote Casa | Ristruttura la tua casa con AI e preventivo", "Scopri come potrebbe diventare la tua casa con SnapQuote Vision. Carica una foto, crea render AI, ottieni una stima dei lavori e richiedi un sopralluogo. Prova gratis.", "og-casa.jpg?v=2"],
  "/casa/sopralluogo": ["Richiedi un sopralluogo · SnapQuote Casa", "Richiedi gratis un sopralluogo per la ristrutturazione della tua casa: ti mettiamo in contatto con imprese compatibili con il tuo progetto e la tua zona.", "og-casa.jpg?v=2"],
  "/casa/pagamenti-protetti": ["Pagamenti protetti per la tua ristrutturazione · SnapQuote Casa", "Come funziona SaldoProtetto per i privati: pagamenti per fasi, verifiche GPS e codice OTP, sblocco solo alle condizioni concordate con l'impresa.", "og-casa.jpg?v=2"],
};
const DEF_IMG = `${SITE_URL}/og-snapquote.jpg`;

function setMeta(attr, key, content) {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function setCanonical(href) {
  let el = document.head.querySelector('link[rel="canonical"]');
  if (!href) { if (el) el.remove(); return; }
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", "canonical");
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

export function RouteMeta() {
  const { pathname } = useLocation();
  useEffect(() => {
    const m = META[pathname];
    const url = SITE_URL + (pathname === "/" ? "/" : pathname);
    const [title, desc, img] = m || ["SnapQuote", DEF_DESC];
    const image = img ? `${SITE_URL}/${img}` : DEF_IMG;
    setMeta("property", "og:image", image);
    setMeta("property", "og:image:secure_url", image);
    setMeta("name", "twitter:image", image);
    document.title = title;
    setMeta("name", "description", desc);
    setMeta("name", "robots", m ? "index, follow" : "noindex, nofollow");
    setCanonical(m ? url : null);
    setMeta("property", "og:url", m ? url : SITE_URL + "/");
    setMeta("property", "og:title", title);
    setMeta("property", "og:description", desc);
    setMeta("name", "twitter:title", title);
    setMeta("name", "twitter:description", desc);
    setMeta("name", "twitter:url", m ? url : SITE_URL + "/");
  }, [pathname]);
  return null;
}
